var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{staticClass:"tag",attrs:{"outlined":"","filled":"","auto-grow":"","readonly":true,"loading":_vm.loading,"value":_vm.content,"background-color":"white"},model:{value:(_vm.codeGenerated),callback:function ($$v) {_vm.codeGenerated=$$v},expression:"codeGenerated"}})
}
var staticRenderFns = []

export { render, staticRenderFns }